import { units } from '@ui/css';
import { combineTokens } from '@utils/css';

const tokens = combineTokens("--course-revisions--share--select", {
  minHeight: units.px(0)
});
const headingCls = "_ibqhy5fp09";
const container = "_ibqc4my0t3";
const search = "_ibqsfrclgb";
const listbox = "_ibql1txjzli";
const buttons = "_ibqbdgspj7";

export { buttons, container, headingCls, listbox, search, tokens };
import "./atom.select.style.linaria.module.css";
//# sourceMappingURL=atom.select.style.js.map
